// extracted by mini-css-extract-plugin
export default {"list":"filter-column__list___2s3HM","heading":"filter-column__heading___1hfPl","opacity":"filter-column__opacity___14X-W"};